import React from 'react'
import RaisedButton from 'material-ui/RaisedButton'
import AttachmentRender from './AttachmentRender'

export default (o) => (
	<div
		onClick={o.close}
		style={{
			display: (o.show)? "block" : "none",
			position: "fixed",
			top: "0",
			right: "0",
			bottom: "0",
			left: "0",
			background: 'rgba(0,0,0,0.8)',
			zIndex: '10000000'
		}}
		className="attachmentPopup"
	>
		<div
			style={{
				width: '600px',
				height: '100%',
				maxWidth: '100%',
				maxHeight: '100%',
				display: 'block',
				position: 'absolute',
				left: '0',
				right: '0',
				top: '0',
				bottom: '0',
				margin: 'auto',
				padding: '3px 30px'
			}}
			onClick={()=>false}
		>
			<p
				style={{
					position: 'absolute'
				  , margin: 'auto'
				  , left: '0'
				  , right: '0'
				  , top: '0'
				  , bottom: 'auto'
				  , height: '28px'
				  , fontSize: '28px'
				  , color: '#FFF'
				  , fontWeight: 'bold'
				  , textAlign: 'center'
				}}
			>
				{o.name}
			</p>
			<AttachmentRender
				style={{
					maxWidth: '60px'
				  , maxHeight: '40px'
				  , overflow: 'hidden'
				  , display: 'inline-block'
				  , margin: '0 5px'
				}}
				attachmentStyle={{
					maxWidth: '80%'
				  , maxHeight: '60%'
				  , position: 'absolute'
				  , overflow: 'hidden'
				  , display: 'inline-block'
				  , left: '0px'
				  , right: '0px'
				  , top: '0px'
				  , bottom: '0px'
				  , margin: 'auto'
				  , textAlign: 'center'
				  , fontSize: '100px'
				  , lineHeight: '270px'
				  , background: '#FFF'
				  , cursor: 'default'
				}}
				file={o.file}
				name={o.name}
				to={o.href}
				link={o.href}
				onClick={(evt)=> {
					evt.preventDefault()
					return false
				}}
				thumb={false}
			/>
			{(!o.noDownload)?
				<RaisedButton
					to={(o.file)?URL.createObjectURL(o.file): (o.href)? o.href : ''}
					download={o.name}
					label="Download"
					style={{
						width: 'calc(100% - 60px)'
					  , position: 'absolute'
					  , bottom: '0'
					}}
					secondary={true}
				/>
				: ""
			}
		</div>
	</div>
)



// WEBPACK FOOTER //
// ./src/components/AttachmentOverlay.js